<script setup>
const props = defineProps({
  item: Object,
})

const hours = computed(() => props.item.enrichment.stopwatch.hours.toString().padStart(2, '0'))
const minutes = computed(() => props.item.enrichment.stopwatch.minutes.toString().padStart(2, '0'))
const seconds = computed(() => props.item.enrichment.stopwatch.seconds.toString().padStart(2, '0'))
</script>

<template>
  <div class="size-full flex items-center justify-center">
    <div class="relative flex items-center justify-center w-[3750px] h-[1500px] top-auto space-x-24 wanted-stopwatch bg-contain bg-no-repeat font-cervo-mono text-white tracking-[-3px] text-[58rem]">
      <div class="absolute bottom-8 right-[2400px]">{{ hours }}</div>
      <div class="absolute bottom-8 right-[1490px]">{{ minutes }}</div>
      <div class="absolute bottom-8 right-[590px]">{{ seconds }}</div>
    </div>
  </div>
</template>

<style scoped>
.wanted-stopwatch {
  background-image: url('../../../assets/images/wanted_stopwatch.png');
}
</style>
